import ptBR from './pt_BR.json'
import es from './es.json'

export default {
  // eslint-disable-next-line
  pt_BR: ptBR,
  es: es
}
